<template>
  <div>

    <v-toolbar app class="nav">
      <v-toolbar-title>
        <router-link to="/orders" tag="span" style="cursor: pointer">
          <img src="../../public/logo.png" :alt="appTitle">
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn  v-for="item in menuItems" :key="item.title"  style="color: white; background: transparent !important; box-shadow: none;">
          <div v-if="loggedinUser.user_data.is_superuser == true || item.public == true">

            <div v-if="item.dropdown == false">
              <router-link :to="item.path" v-if="item.newTab != true" style="text-decoration: none; display: inherit;color: white;">
                <v-icon left dark style="color: black;">{{ item.icon }}</v-icon>
                {{ item.title }}
              </router-link>
              <a :href="item.path" target="_blank" v-else style="text-decoration: none; display: inherit;color: white;">
                <v-icon left dark style="color: black;">{{ item.icon }}</v-icon>
                {{ item.title }}
              </a>
            </div>
            <v-menu v-else transition="slide-y-transition" bottom>
              <template v-slot:activator="{ on }">
                <!-- <v-btn
                  class="purple"
                  color="primary"
                  dark
                  v-on="on"
                >
                  Slide Y Transition
                </v-btn>-->
                <div v-on="on">
                  <v-icon left dark>{{ item.icon }}</v-icon>
                  {{ item.title }}
                </div>
              </template>
              <v-list>
                <v-list
                  nav
                >
                  <!-- <v-subheader>User Settings</v-subheader> -->
                  <v-list-item-group v-model="menu" color="primary">
                    <v-list-item
                      v-for="(menu, i) in item.menu"
                      :key="i"
                      :inactive="inactive"
                    >
                      <a v-if='menu.title==="Roles" && (loggedinUser.user_data.is_superuser == true || menu.public == true)' :href="menu.url" style="text-decoration: none; display: inherit;">
                        <v-list-item-avatar>
                          <v-icon left color="primary">{{ menu.icon }}</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-html="menu.title"></v-list-item-title>
                        </v-list-item-content>
                      </a>
                      <a v-else-if="loggedinUser.user_data.is_superuser == true || menu.public == true" :href="menu.url" target="_blank" style="text-decoration: none; display: inherit;">
                        <v-list-item-avatar>
                          <v-icon left color="primary">{{ menu.icon }}</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-html="menu.title"></v-list-item-title>
                        </v-list-item-content>
                      </a>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-list>
            </v-menu>
          </div>
          <!-- <v-select
            v-else
            :items="item.menu"
            :label="item.title"
            attach
            chips
          ></v-select>-->
        </v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn >

          <v-menu transition="slide-y-transition" bottom offset-y=false>
            <template v-slot:activator="{ on }">
              <!-- <v-btn
                class="purple"
                color="primary"
                dark
                v-on="on"
              >
                Slide Y Transition
              </v-btn>-->
              <div v-on="on">
                <v-icon left dark>account_circle</v-icon>
                {{loggedinUser.user_data.first_name}}
              </div>
            </template>
            <v-card
              class="mx-auto"
              max-width="400"
              tile
            >
              <v-list
                nav
              >
                <v-subheader>User Settings</v-subheader>
                <v-list-item-group v-model="item" color="primary">
                  <v-list-item
                    v-for="(item, i) in authItems"
                    :key="i"
                    :inactive="inactive"
                    @click="item.method"
                  >
                    <v-list-item-avatar>
                      <v-img :src="item.avatar"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="item.title"></v-list-item-title>
                      <v-list-item-subtitle v-if="twoLine || threeLine" v-html="item.subtitle"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import JwtService from '../common/jwt.service'
import { LOGOUT } from '../store/actions.type'
import BASE_API_URL from '@/common/config'

export default {
  name: 'Header',
  data () {
    return {
      appTitle: 'RTS 3.0',
      sidebar: false,
      authItems: [
        {
          title: 'Logout',
          url: '',
          method: this.logout
        }
      ],
      menuItems: [
        {
          title: 'Orders',
          path: '/',
          icon: 'description',
          dropdown: false,
          newTab: false,
          public: true
        },
        {
          title: 'Reports',
          path: 'http://dashboard.wondha.com:8088/',
          icon: 'insert_chart_outlined',
          dropdown: false,
          newTab: true,
          public: false
        },
        {
          title: 'User Manager',
          path: `${BASE_API_URL.BASE_API_URL}/admin/users/user/`,
          icon: 'person',
          dropdown: false,
          newTab: true,
          public: false
        },
        {
          title: 'Preferences',
          path: '#',
          icon: 'settings',
          dropdown: true,
          public: JwtService.assignerCheck(),
          menu: [
            {
              icon: 'settings',
              title: 'Products',
              url: `${BASE_API_URL.BASE_API_URL}/admin/orders/products/`,
              public: false
            },
            {
              icon: 'settings',
              title: 'Clients',
              url: `${BASE_API_URL.BASE_API_URL}/admin/clients/clients/`,
              public: false
            },
            {
              icon: 'settings',
              title: 'State & Counties',
              url: `${BASE_API_URL.BASE_API_URL}/admin/addresses/`,
              public: false
            },
            {
              icon: 'settings',
              title: 'Roles',
              url: `/roles/`,
              public: false
            },
            {
              icon: 'settings',
              title: 'Order Assignment',
              url: `/vendor-assignment/`,
              public: JwtService.assignerCheck()
            }
          ]
        },
        { title: 'Search', newTab: false, path: '/advance-search', icon: 'search', dropdown: false, public: true }
      ]
    }
  },
  computed: {

    loggedinUser () {
      return JwtService.getLoggedInUserData()
    }
  },
  methods: {
    logout () {
      this.$store.dispatch(LOGOUT).then(() => {
        if (this.$store.state.auth.errors == null) {
          // location.href = '/sessions';
          this.$router.push(`/login`)
        }
      })
    }
  }
}
</script>

<style>
.nav.theme--light.v-sheet {
  background-color: #00acac;
  border-bottom: 1px solid #008a8a;
  color: rgba(0, 0, 0, 0.87);
  height: 66px !important;
}
/* .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #f5f5f500;
    color: white;
  } */

.v-btn--active {
  opacity: 1;
  color: #000 !important;
  background-color: #e7edf0 !important;
}
</style>
